// extracted by mini-css-extract-plugin
export var dropdownButton = "_w-0";
export var fullWidthDropdownButton = "_w-1";
export var icon = "_w-3";
export var iconPlaceholder = "_w-2";
export var menuItemRow = "_w-9";
export var separator = "_w-e";
export var shortcutContainer = "_w-7";
export var shortcutContainerFilled = "_w-8";
export var shortcutIconLg = "_w-6";
export var shortcutIconMd = "_w-5";
export var shortcutIconSm = "_w-4";
export var submenuChevron = "_w-d";
export var submenuDropdown = "_w-a";
export var submenuTriggerRow = "_w-b";
export var submenuTriggerRowOpen = "_w-c";